import React from 'react'
import { InputText as UiKitInput } from '@elamajs/ui-kit'

import * as Styled from './Input.styled'

const Input = ({ ...props }) => {
  return <Styled.Input width="100%" as={UiKitInput} {...props} />
}

export default Input
